export const extractJSONObjects = <T = any>(buffer: string): [T[], string] => {
  const results: T[] = [];

  let startIdx = 0;
  let braceCount = 0;
  let insideObject = false;

  for (let i = 0; i < buffer.length; i += 1) {
    const char = buffer[i];

    if (char === '{') {
      if (!insideObject) {
        startIdx = i;
        insideObject = true;
      }

      braceCount += 1;
    } else if (char === '}') {
      braceCount -= 1;

      if (braceCount === 0 && insideObject) {
        const jsonStr = buffer.slice(startIdx, i + 1);
        try {
          results.push(JSON.parse(jsonStr));
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn(`Failed to parse JSON: ${jsonStr}`, e);
        }

        insideObject = false;

        buffer = buffer.slice(i + 1);
        i = -1;
      }
    }
  }

  return [results, buffer];
};
